<template>
	<div>
		<div :class="[{'active':load,'full-page':fullPage, 'card-loader':cardLoader}, 'loader-wrapper']">
			<div :class="[{'loader':cardLoader, 'position-relative':cardLoader == false}]">


				<div :class="['spinner-loader',{'spinner-card':cardLoader}, 'spinner-size-'+size]">
					<svg class="circular" viewBox="25 25 50 50">
						<circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/>
					</svg>
				</div>
				
				
				<h5 class="mt-3" v-if="header != ''">{{(header == null) ? 'Loading' : header}}</h5>
				<p v-if="showText" :class='{"slideIn animate": showText}'>{{showText}}</p>

				<span :class="[{'loader-label':cardLoader == false}]">
					<slot></slot>
				</span>


			</div>


		</div>
	</div>
</template>



<script>
	export default {
		name: 'loader',
		data:() => ({
			showText:null,
			autoPlay: false
		}),
		props:{
			load:{
				type:Boolean,
				default:false,
			},
			header:{
				type:String,
				default:null
			},
			text:{
				type:String,
				default:''
			},
			showTextAfter:{
				type:Number,
				default:0
			},
			fullPage:{
				type:Boolean,
				default:false
			},
			cardLoader:{
				type:Boolean,
				default:true
			},
			size:{
				type:String,
				default:"md",
			},
		},
		created(){
			this.autoPlay = true;
			
		},
		watch:{
			load(){
				setTimeout(()=>{
					this.showText = this.text;
				} , this.showTextAfter * 1000);
			}
		}
	}
</script>